import {BaseFormModel} from './base-form-model';

export class MenuSelectionPrice extends BaseFormModel<MenuSelectionPrice> {
    id: number;
    countMin: number;
    countMax: number;
    price: number;
}
